
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {MainService} from 'src/app/Services/service.service';
import {displayModeType} from 'src/app/Adv/search-results/search-results.component';
import {PageEvent} from '@angular/material';
import {DTOAdvertisementEx} from 'src/app/api/LocalModels';
import * as moment from "moment";
import {DTOAdvertisement, ShowAdType} from "../../api/WickedApiClient";
import { ViewMode } from './../../../Services/advertisement.service';
import { AdvUserAdvertisementsComponent } from './../../../Adveristments/adv-user-advertisements/adv-user-advertisements.component';

@Component({
  selector: 'app-non-demo-ads.component',
  templateUrl: './non-demo-ads.component.html',
  styleUrls: ['./non-demo-ads.component.scss']
})
export class NonDemoAdsComponent extends AdvUserAdvertisementsComponent {
  public enableSubscription:boolean = false;

  constructor(public route: ActivatedRoute, public service: MainService) {
    super(route, service);
    this.enableSubscription = service.enableSubscription;
    service.pageName = "Non Demo Ads";
  }

  ngOnInit() {
    if (!this.service.userService.isAdmin()) {
      this.service.route.navigate(["/"]);
    }

    if (!this.service.userService.isDemo()) {
      this.viewMode=ViewMode.ACTIVE;
    }
    this.performSearch();
  }

  public performSearch() {
    this.service.advService.searchDataUserAdv.currentSearchRule.nonDemoOnly = true;
    this.service.advService.searchDataUserAdv.currentSearchRule.userId = null;
    this.service.advService.searchActionForUser(this.viewMode);
  }

 

  public set pageEvent(value: PageEvent) {
    this.service.advService.searchDataUserAdv.currentSearchRule.pageNumber = value.pageIndex;
    this.service.advService.searchDataUserAdv.currentSearchRule.pageSize = value.pageSize;
    this.service.advService.searchDataUserAdv.currentSearchRule.nonDemoOnly = true;
    this.service.advService.searchDataUserAdv.currentSearchRule.userId = null;
    this.service.advService.searchActionForUser(this.viewMode);
    this._pageEvent = value;
  }

  public hasAdvertismentImage(advertisment: DTOAdvertisement): boolean {
    return advertisment.images.length > 0;
  }
  public getLocation(adv: DTOAdvertisementEx) {
    return adv.subRegionName + ", " + adv.regionShortName;
  }

  public getAdvDate(adv: DTOAdvertisementEx) {
    if (adv.dateStart != null) {
      return adv.dateStart.format("MM/DD/YYYY")
    } else return "";
  }

  public getAdvTag(adv: DTOAdvertisementEx) {
    var tag = this.service.advService.searchDataStandard.currentSearchRule.advertisementCategoryId ? "" : `[${adv.categoryCode}] `;
    return `${tag}`;
  }

  public getAdvTitle(adv: DTOAdvertisementEx) {
    return `${adv.title}`;
  }

  openAdv(id: string) {
    this.service.route.navigate([`adv-detail/${id}`]);
  }

  editAdv(id: string) {
    this.service.route.navigate([`adv-edit/${id}`]);
  }

  showTip(e){
    e.stopPropagation();

    e.target.getElementsByClassName("textTip")[0].style.opacity = "1";
    setTimeout(function(){ 
      e.target.getElementsByClassName("textTip")[0].style.opacity = "0";
    }, 2000);
    
  }
}


